import { ShieldCheck, BadgeCheck, PlaneTakeoff, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const icons = [BadgeCheck, ShieldCheck, PlaneTakeoff, Clock];

export const WhyUs = () => {
  const { t } = useLang();
  return (
    <section className="py-20 md:py-32 bg-jungle text-sand relative overflow-hidden" data-testid="why-section">
      <img
        src="https://images.unsplash.com/photo-1773102722675-725dbe7ad75e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxtZXhpY28lMjBqdW5nbGUlMjByZXNvcnQlMjBuYXR1cmV8ZW58MHx8fHwxNzgxNzI2ODE0fDA&ixlib=rb-4.1.0&q=85"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-10"
      />
      <div className="relative px-6 md:px-12 lg:px-20 mx-auto max-w-7xl">
        <div className="max-w-2xl mb-16">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-teal font-bold mb-4">{t.why.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-sand">{t.why.title}</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {t.why.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div key={i} data-testid={`why-item-${i}`} className="border-t border-sand/20 pt-6">
                <Icon size={32} className="text-teal mb-5" strokeWidth={1.5} />
                <h3 className="font-heading text-2xl font-semibold text-sand mb-2">{item.title}</h3>
                <p className="font-body text-sm text-sand/70 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
